// frontend/src/components/admin/modals/CancelTournamentModal.jsx
import React, { useState } from 'react';
import axios from '../../../config/axios';
import { AlertTriangle } from 'lucide-react';

const CancelTournamentModal = ({ tournament, onClose, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleCancel = async () => {
        setLoading(true);
        setError('');

        try {
            const response = await axios.post(`/admin/tournaments/${tournament.id}/cancel`);
            if (response.data.success) {
                onSuccess();
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Error al cancelar el torneo');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <div className="flex items-center gap-3 text-yellow-600 mb-4">
                    <AlertTriangle className="w-6 h-6" />
                    <h2 className="text-xl font-bold">Cancelar Torneo</h2>
                </div>

                <div className="space-y-4">
                    <p className="text-gray-600">
                        ¿Estás seguro que deseas cancelar el torneo "{tournament.name}"?
                    </p>

                    <div className="bg-yellow-50 p-4 rounded-md">
                        <p className="text-sm text-yellow-800">
                            Esta acción:
                            <ul className="list-disc ml-5 mt-2 space-y-1">
                                <li>Devolverá los tickets a todos los participantes</li>
                                <li>Eliminará el torneo del sistema</li>
                                <li>No se puede deshacer</li>
                            </ul>
                        </p>
                    </div>

                    {error && (
                        <p className="text-red-500 text-sm">{error}</p>
                    )}

                    <div className="flex justify-end space-x-3 mt-6">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                            disabled={loading}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            onClick={handleCancel}
                            disabled={loading}
                            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50"
                        >
                            {loading ? 'Procesando...' : 'Confirmar Cancelación'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CancelTournamentModal;